<template>
    <div>
      <div class="d-flex justify-content-between align-items-center">
        <!-- Component Title -->
        <div>
          <div class="d-flex">
            <font-awesome-icon class="component-icon" :icon="statsData.component.icon" :style="{ color: statsData.component.iconColor }"/>
            <h4 class="component-title ml-3">{{ statsData.component.title }}</h4>
          </div>
          <div>
            <span v-if="!hasTwoLines" class="text-muted"><b>{{ statsData.component.sendDate > Date.now() ? "To be sent on:" : "Sent:" }}</b> {{ statsData.component.sendDate | formatDate('Do MMMM YYYY') }}</span>
            <div v-else class="d-flex">
              <span class="text-muted">
                <b>{{ statsData.component.startDate > Date.now() ? "Starts:" : "Started:" }}</b> {{ statsData.component.startDate | formatDate('Do MMMM YYYY, HH:mm') }} &nbsp; <b>{{ statsData.component.endDate > Date.now() ? "Ends:" : "Ended:" }}</b> {{ statsData.component.endDate | formatDate('Do MMMM YYYY, HH:mm') }}
              </span>
            </div>
          </div>
        </div>
        <!-- Component Stats -->
        <b-row class="d-flex justify-content-around align-items-center">
          <template v-for="({ label, value, key }) in (!hasTwoLines ? displayStats.main : displayStats.top)">
            <div class="campaign-score-block d-flex flex-column justify-content-center align-items-end mr-3" :key="`${key}-block`">
              <span class="component-display-count text-muted">{{ value }}</span>
              <span class="score-display-label" v-if="label">{{ label }}</span>
              <span class="score-display-label" v-else>{{ key }}</span>
            </div>
          </template>
        </b-row>
    </div>
    <hr v-if="hasTwoLines">
    <div v-if="hasTwoLines">
      <b-row align-h="between" class="pt-1">
        <b-col cols="12" md="7">
          <stats-block :componentData="displayStats.left"/>
        </b-col>
        <b-col cols="12" md="5">
          <stats-block :componentData="displayStats.right" :isRightAligned="true"/>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import StatsBlock from '@/components/campaign-admin/StatsBlock.vue';
import formatDate from 'date-fns/format';

export default {
  components: {
    StatsBlock
  },
  props: {
    statsData: {
      type: Object,
      required: true,
    },
    statPositions: {
      type: Object,
      default: () => ({
        main: [ 'users', 'opened', 'clicked' ],
        top: [ 'users', 'jobs', 'content' ],
        left: [ 'jobShares', 'jobViews', 'contentShares', 'contentViews' ],
        right: [ 'applications', 'interviews', 'hires' ],
      })
    },
  },
  computed: {
    formatDate: () => formatDate,
    lastKey() {
      return Object.keys(this.values).pop();
    },
    displayStats() {
      const { statPositions } = this;
      const stats = this.statsData.stats;
      return stats.reduce((out, { key, value, label }) => {
        if (statPositions.main.includes(key)) {
          out.main.push({ label, value, key });
        }
        if (statPositions.top.includes(key)) {
          out.top.push({ label, value, key });
        }
        if (statPositions.left.includes(key)) {
          out.left.push({ label, value, key });
        }
        if (statPositions.right.includes(key)) {
          out.right.push({ label, value, key });
        }
        return out;
      }, { top: [], left: [], right: [], main: [] });
    },
    hasTwoLines() {
      if (this.displayStats.left.length === 0 || this.displayStats.right.length === 0) {
        return false;
      }
      return true;
    },
  },
};
</script>

<style lang="scss">
  .component-title {
    font-size: 1.3rem;
  }
  .component-icon {
    font-size: 1.5rem;
  }

  .component-display-count {
    font-weight: bold;
    font-size: 18px;
  }

  .campaign-score-block {
    width: 115px;

    .score-display-count {
      font-weight: bold;
      font-size: 23px;
    }

    .score-display-label {
      font-size: 12px;
      text-align: center;
      text-transform: uppercase;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/campaign-admin/ComponentStats.vue